var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"recursive-menu"},[_vm._l((_vm.data),function(item){return [_c('RecursiveMenuItem',{key:item.title,staticClass:"recursive-menu-item-root",attrs:{"data":item}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }